import { useState, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const FreeTrialModal = ({ open, handleClose, handleSubmit, planDetails }) => {
  const startDate = new Date();
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 7); // Trial ends in 7 days

  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = endDate - now;
    if (difference <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleTrialSubmit = () => {
    handleSubmit(planDetails);
    handleClose();
  };

  // Use the theme from your application, or create a simple one that matches your design
  const theme = createTheme({
    // Define your theme here if needed
  });

  return (
    <Dialog
    open={open}
    onClose={handleClose}
    maxWidth="sm"
    fullWidth
    sx={{
      '& .MuiDialog-paper': {
        textAlign: 'center', // center all inside text
       
      },
    }}
  >
  
      <DialogTitle sx={{ fontSize: 24, fontWeight: 600, color: theme => theme.palette.text.primary }}>
        Start Your Free Trial 🚀
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <Typography variant="body1" sx={{ mb: 2, color: theme => theme.palette.text.primary }}>
            Enjoy all features of the <b>{planDetails?.name || 'Premium'}</b> plan for <b>7 days</b>!
          </Typography>

          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 0.5 }}>✅ 30,000 Email Validation</Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>✅ 1,000,000 Email Sending</Typography>
            <Typography variant="body2">✅ 1,000,000 Phone Exports</Typography>
          </Box>

          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            Trial Start: <b>{startDate.toLocaleString()}</b><br />
            Trial End: <b>{endDate.toLocaleString()}</b>
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, fontWeight: 700, color: 'error.main' }}>
            Time Left: {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent : 'center' , px: 3, pb: 3, pt: 1 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ minWidth: 100 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleTrialSubmit}
          color="primary"
          sx={{ minWidth: 100 }}
        >
          Start Trial
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FreeTrialModal;